import { useState, useEffect, useRef } from "react"
import { Layout } from "element-react"
import { useTranslation } from 'react-i18next';
import { useParams } from "react-router-dom";

import { BiChat } from "react-icons/bi";

import ChatTitle from "../components/ChatTitle"
import ChatItemsSearchBox from "../components/ChatItemsSearchBox"
import ChatMessageInputs from "../components/ChatMessageInputs"

import ChatItemsContainer from "../components/ChatItemsContainer";
import ChatMessagesContainer from "../components/ChatMessagesContainer";
import ChatEmptyInbox from "../components/ChatEmptyInbox";

import { RiMenuLine } from "react-icons/ri"; // Icono para el botón de menú
import { IoClose } from "react-icons/io5"; // Icono para el botón de cerrar

export default function MyChats() {
    const {t} = useTranslation();    
    const [[selectedChat, setSelectedChat], [chatTextFilter, setChatTextFilter], [chatTypeFilter, setChatTypeFilter], [hasNoChats, setHasNoChats]] = [useState(null), useState(""), useState(""), useState(false)]
    let { id } = useParams();

    const [isPanelVisible, setPanelVisible] = useState(false);
    const panelRef = useRef(null);
    const triggerRef = useRef(null); // Referencia para la barra gris
    const [panelTop, setPanelTop] = useState(0);

    const handleSelectChat = (chat) => {

        console.log('%c handleSelectChat fue llamada con: ', 'background: #222; color: #bada55', chat);
    
        setSelectedChat(chat);
        setPanelVisible(false); // Cierra el panel al seleccionar
    };

    const handleShowContacts = () => {
        setPanelVisible(true);
    };

    const handleTriggerClick = () => {
        setPanelVisible(!isPanelVisible);
    };

    useEffect(() => {
        // Función que revisa si debe mostrar el panel
        const checkAndShowPanel = () => {
            if (window.innerWidth <= 767 && !selectedChat) {
                setPanelVisible(true);
            }
        };

        // Llama a la función al cargar el componente
        checkAndShowPanel();

        // Agrega un listener para reaccionar si cambia el tamaño de la ventana
        window.addEventListener('resize', checkAndShowPanel);

        // Limpia el listener cuando el componente se destruye para evitar fugas de memoria
        return () => {
            window.removeEventListener('resize', checkAndShowPanel);
        };
    }, [selectedChat]); 

    useEffect(() => {
        function handleClickOutside(event) {
            // La condición : si el clic es afuera Y si ya hay un chat seleccionado
            if (panelRef.current && !panelRef.current.contains(event.target) && selectedChat) {
                setPanelVisible(false); 
            }
        }

        if (isPanelVisible) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isPanelVisible, selectedChat]);

    useEffect(() => {
        // Cuando el componente del chat se monta, añadimos la clase al body
        document.body.classList.add('on-chat-page');

        return () => {
            document.body.classList.remove('on-chat-page');
        };
    }, []);

    useEffect(() => {
        // Función única para calcular y actualizar la posición
        const updatePanelPosition = () => {
            if (triggerRef.current) {
                const { bottom } = triggerRef.current.getBoundingClientRect();
                setPanelTop(bottom);
            }
        };

        if (isPanelVisible) {
            updatePanelPosition(); 
            window.addEventListener('resize', updatePanelPosition); 
        }

        return () => {
            window.removeEventListener('resize', updatePanelPosition);
        };
    }, [isPanelVisible]);

    return (
        <>
        <Layout.Row className="Contain-mychat">
            <Layout.Col span={24} md={{span: 20, offset: 2}} className="m-t-md m-b-sm chat-header">
                <h2 className="main-page-title">{t('chat.title')}</h2>
            </Layout.Col>
            
            {/* --- CONTENEDOR PRINCIPAL DEL CHAT --- */}
            <Layout.Col span={24} md={{span: 20, offset: 2}} className="m-b-xl container-mobileChat">
                
                {hasNoChats ? (
                    <ChatEmptyInbox />
                ) : (
                    <>
                        {/* --- MENÚ DESPLEGABLE (SOLO MÓVIL) --- */}
                        <div className="mobile-only" style={{width: "100%"}} ref={panelRef}>
                            <div className="contacts-dropdown-trigger" 
                                onClick={handleTriggerClick}
                                ref={triggerRef}>
                                View All Contacts
                                <span className={`arrow ${isPanelVisible ? 'up' : 'down'}`}></span>
                            </div>
                            <div className={`contacts-dropdown-panel ${isPanelVisible ? 'is-open' : ''}`} style={{ top: `${panelTop}px` }}>
                                <ChatItemsContainer 
                                    indexChat={id} 
                                    onChatSelect={handleSelectChat} 
                                    filterValue={chatTextFilter} 
                                    chatTypeFilter={chatTypeFilter} 
                                    onEmptyChats={setHasNoChats}
                                />
                            </div>
                        </div>

                        <Layout.Row className="chat-main-container">
                            {/* --- COLUMNA IZQUIERDA (SOLO ESCRITORIO) --- */}
                            <Layout.Col md={9} className="p-r-md desktop-only">
                                <ChatItemsSearchBox onInputChange={setChatTextFilter} onChatTypeChange={setChatTypeFilter} />
                                <ChatItemsContainer 
                                    indexChat={id} 
                                    onChatSelect={handleSelectChat} 
                                    filterValue={chatTextFilter} 
                                    chatTypeFilter={chatTypeFilter} 
                                    onEmptyChats={setHasNoChats}
                                />
                            </Layout.Col>

                            {/* --- COLUMNA DERECHA (CHAT ACTIVO) --- */}
                            {selectedChat ? (
                                <Layout.Col xs={24} md={15} className="chat-content-column">
                                    <ChatTitle chat={selectedChat} />
                                    <ChatMessagesContainer chat={selectedChat} />
                                    <ChatMessageInputs chat={selectedChat} />
                                </Layout.Col>
                            ) : (
                                <div className="chat-non-chat-selected desktop-only">
                                    <BiChat size={80} className="m-b-md"/><br />
                                    {t('chat.please-select-chat')}
                                </div>
                            )}
                        </Layout.Row>
                    </>
                )}

            </Layout.Col>
        </Layout.Row>
    
    </>)
}
